export const DateFormat = {
	STANDARD: "YYYY-MM-DD", // 2024-22-02
	SHORT_DATE: "DD/MM/YYYY", // 24/03/2021
	SHORT_DATETIME: "DD/MM/YYYY HH:mm", // 24/03/2021 15:30
	SHORT_LONG_DATE: "ddd D MMM YYYY", // Tue 6 Apr 2021
	LONG_DATE: "dddd D MMMM YYYY", // Tuesday 6 April 2021
	LONG_DATETIME: "dddd D MMMM YYYY HH:mm", // Tuesday 6 April 2021 14:30,
	LONG_DATE_WITHOUT_YEAR: "dddd D MMMM" // Tuesday 6 April
};
